import { z } from 'zod';
import {
  MemoryRecordResponseSchema,
  MemorySessionSchema,
  MemoryEventSchema,
} from './memory.schema';

export const ListMemoryRecordsResponseSchema = z.object({
  records: z.array(MemoryRecordResponseSchema),
  totalCount: z.int().nonnegative(),
});
export type ListMemoryRecordsResponse = z.infer<
  typeof ListMemoryRecordsResponseSchema
>;

export const ListMemorySessionsResponseSchema = z.object({
  sessions: z.array(MemorySessionSchema),
  totalCount: z.int().nonnegative(),
});
export type ListMemorySessionsResponse = z.infer<
  typeof ListMemorySessionsResponseSchema
>;

export const ListMemoryEventsResponseSchema = z.object({
  events: z.array(MemoryEventSchema),
  totalCount: z.int().nonnegative(),
});
export type ListMemoryEventsResponse = z.infer<
  typeof ListMemoryEventsResponseSchema
>;

export const GetMemoryRecordResponseSchema = MemoryRecordResponseSchema;
export type GetMemoryRecordResponse = z.infer<
  typeof GetMemoryRecordResponseSchema
>;

export const CreateMemoryEventResponseSchema = z.object({
  success: z.boolean(),
  sessionId: z.string().optional(),
  recordId: z.string().optional(),
  outcome: z.enum(['created', 'merged', 'updated', 'submitted']).optional(),
  version: z.number().int().positive().optional(),
});
export type CreateMemoryEventResponse = z.infer<
  typeof CreateMemoryEventResponseSchema
>;
